import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

/** SKU has no rate in the chosen pricing type → pick one that has it (stickers would otherwise print blank). */
export const PricingTypePrompt = ({ prompt, onPick, onCancel }) => (
  <Dialog open={!!prompt} onOpenChange={(o) => !o && onCancel()}>
    <DialogContent className="max-w-md" data-testid="pricing-type-prompt">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-amber-600" />Pick the Pricing Type</DialogTitle>
        <DialogDescription>
          {prompt?.what || 'Bundle'} <b>{prompt?.code}</b>: SKU <b className="font-mono" data-testid="pricing-type-prompt-skus">{prompt?.barcodes.join(', ')}</b> has no <b>{prompt?.pt}</b> rate
          in Rates Master, so the stickers would print blank. Nothing was printed.
        </DialogDescription>
      </DialogHeader>
      {prompt?.options.length ? (
        <div className="space-y-2">
          <p className="text-sm text-gray-600">Print with the pricing type that has its rates:</p>
          <div className="flex flex-wrap gap-2">
            {prompt.options.map((o) => (
              <Button key={o} variant="outline" className="min-w-[72px] font-semibold" onClick={() => onPick(o)} data-testid={`pricing-type-prompt-opt-${o}`}>{o}</Button>
            ))}
          </div>
        </div>
      ) : (
        <p className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-800" data-testid="pricing-type-prompt-none">This SKU has no rate in any pricing type — add its rates in Rates Master first.</p>
      )}
      <DialogFooter><Button variant="ghost" onClick={onCancel} data-testid="pricing-type-prompt-cancel">Cancel</Button></DialogFooter>
    </DialogContent>
  </Dialog>
);

export default PricingTypePrompt;
